import React, { useEffect, useState } from 'react'
import DataUsageIcon from '@mui/icons-material/DataUsage'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import {
  // Alert,
  Box,
  CircularProgress
} from '@mui/material'
import Accordion from '@mui/material/Accordion'
import AccordionDetails from '@mui/material/AccordionDetails'
import AccordionSummary from '@mui/material/AccordionSummary'
import { useQuery } from '@tanstack/react-query'
import DataApi from 'api/faber/DataApi'
import OneTimePackApi from 'api/faber/OneTimePackApi'
import NormalText from 'common/Typography/NormalText'

import { RefundFormV2 } from './RefundFormV2'
export function RefundDataCheck({
  faberToken,
  iccid,
  refundDialogOpen,
  setIsDataUsageZero,
  customerEmail,
  isRefundLoading,
  handleRefundLoading,
  customerId,
  transactionType,
  mutateRefundOtpack
}: DataCheckProps) {
  //DATA CHECK FOR OTPACKS
  const [totalOtpackDataUsed, setTotalOtpackDataUsed] = useState(0)

  //GET ALL ACTIVE OTPACK USER PLANS API
  const { data: getActiveplan, refetch: refetchGetAllActivePlans } = useQuery(
    ['getAllActiveOtpackUserPlans', customerId],
    async () => {
      const activePlan = await OneTimePackApi.getActiveOtpUserPacks(
        customerId,
        faberToken
      )
      return activePlan
    },
    {
      onError: () => {
        return []
      }
    }
  )

  useEffect(() => {
    if (getActiveplan) {
      if (getActiveplan.data.body.data.length > 0) {
        const activeTotalData = getActiveplan.data.body.data.reduce(
          (accumulator, item) => accumulator + item.packageDataAllowed,
          0
        )
        const activeDataRemaining = getActiveplan.data.body.data.reduce(
          (accumulator, item) => accumulator + item.packageDataRemaining,
          0
        )

        setTotalOtpackDataUsed(activeTotalData - activeDataRemaining)
      } else {
        setTotalOtpackDataUsed(0)
      }
    }
  }, [getActiveplan])

  //DATA CHECK FOR SUBSCRIPTION
  const {
    data: dataUsageCheck,
    isLoading: isCheckDataQueryLoading,
    refetch: refetchDataCheck
  } = useQuery(
    ['getUserDataCheck'],
    async () => {
      const dataCheckResponse = await DataApi.getUserDataCheck(
        iccid,
        faberToken
      )

      return dataCheckResponse.data.totalDataUsedMB
    },
    {
      onSuccess: (res) => {
        setIsDataUsageZero(res === 0)
      },
      enabled: !!iccid && refundDialogOpen
    }
  )

  const convertToGB = (data: undefined | number) => {
    if (data !== undefined) {
      return (data / 1000).toFixed(3)
    }
  }

  useEffect(() => {
    refetchDataCheck()
    refetchGetAllActivePlans()
  }, [refundDialogOpen])

  return (
    <>
      {isCheckDataQueryLoading ? (
        <CircularProgress />
      ) : (
        <>
          <Box
            sx={{
              mt: 1,
              mx: 2,
              p: 2,
              borderRadius: '12px',
              boxShadow: 'rgba(0, 0, 0, 0.05) 0px 0px 0px 1px'
            }}
          >
            <Box sx={{ display: 'flex' }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <DataUsageIcon sx={{ color: 'primary.dark' }} />
                <NormalText isBold sx={{ color: 'primary.dark' }}>
                  Customer&apos;s Data Usage:
                </NormalText>
              </Box>

              {transactionType.includes('ONETIMEPACK') ? (
                <NormalText
                  isBold={totalOtpackDataUsed !== 0}
                  sx={{
                    ml: 1,
                    color: totalOtpackDataUsed === 0 ? '#33c75a' : 'red'
                  }}
                >
                  {totalOtpackDataUsed} GB{' '}
                </NormalText>
              ) : (
                <NormalText
                  isBold={dataUsageCheck !== 0}
                  sx={{
                    ml: 1,
                    color: dataUsageCheck === 0 ? '#33c75a' : 'red'
                  }}
                >
                  {convertToGB(dataUsageCheck)} GB{' '}
                </NormalText>
              )}
            </Box>
          </Box>
          {/* {totalOtpackDataUsed > 0.5 &&
          transactionType.includes('ONETIMEPACK') ? (
            <Alert severity='error' sx={{ mx: 2, mt: '1rem' }}>
              Customer has used more than 500mb of data of their active
              one-time-packs, no refunds should be given{' '}
            </Alert>
          ) : ( */}
          <Accordion
            defaultExpanded
            sx={{
              mt: 1,
              '&.MuiPaper-root': {
                boxShadow: 'none'
              },
              '&::before': {
                backgroundColor: 'transparent'
              }
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls='panel1a-content'
              id='panel1a-header'
              sx={{
                '.MuiAccordionSummary-content': {
                  m: 0
                }
              }}
            >
              <NormalText
                isBold
                sx={{ color: 'primary.dark', fontSize: '1em' }}
              >
                Request Form
              </NormalText>
            </AccordionSummary>

            <AccordionDetails>
              <RefundFormV2
                mutateRefundOtpack={mutateRefundOtpack}
                transactionType={transactionType}
                key='refund-form'
                totalOtpackDataUsed={totalOtpackDataUsed}
                customerEmail={customerEmail}
                isRefundLoading={isRefundLoading}
                handleRefundLoading={handleRefundLoading}
                customerId={customerId}
              />
            </AccordionDetails>
          </Accordion>
          {/* )} */}
        </>
      )}
    </>
  )
}

interface DataCheckProps {
  faberToken: string
  iccid: string
  refundDialogOpen: boolean
  setIsDataUsageZero: (value: boolean) => void
  customerEmail: string
  isRefundLoading: boolean
  handleRefundLoading: () => void
  customerId: string
  transactionType: string
  mutateRefundOtpack: ({
    faberToken,
    refundPaymentID,
    refundReason,
    userId,
    ticketId
  }) => void
}
